import BigNumber from "bignumber.js";
import { displayAmount } from "src/utils/helper";

import { getMaxDisplayDecimals } from "../../helpers/getMaxDisplayDecimals";
import { TabTypes } from "../../types";

interface IProps {
  fromCurrency: string;
  toCurrency: string;
  exactAmount: string;
  estimatedAmount: string;
  mode: TabTypes;
  fromCurrencyDecimals: number;
  toCurrencyDecimals: number;
}

const createExactPayExchangeRateDisplay = (props: any) => {
  const {
    fromCurrency,
    toCurrency,
    exactAmount,
    estimatedAmount,
    mode,
    fromCurrencyDecimals,
    toCurrencyDecimals,
  } = props;

  const fromToExchangeRate = BigNumber(estimatedAmount)
    .dividedBy(Math.pow(10, toCurrencyDecimals))
    .dividedBy(exactAmount)
    .decimalPlaces(getMaxDisplayDecimals(Number(toCurrencyDecimals)), 1)
    .toFixed()
    .toString();

  const toFromExchangeRate = BigNumber(exactAmount)
    .dividedBy(
      BigNumber(estimatedAmount).dividedBy(Math.pow(10, toCurrencyDecimals))
    )
    .decimalPlaces(getMaxDisplayDecimals(Number(fromCurrencyDecimals)), 1)
    .toFixed()
    .toString();

  const fromToExchangeRateDisplay = `1 ${fromCurrency} = ${displayAmount(
    fromToExchangeRate,
    0
  )} ${toCurrency}`;
  const toFromExchangeRateDisplay = `1 ${toCurrency} = ${displayAmount(
    toFromExchangeRate,
    0
  )} ${fromCurrency}`;

  return `${fromToExchangeRateDisplay} \n ${toFromExchangeRateDisplay}`;
};

const createExactGetExchangeRateDisplay = (props: any) => {
  const {
    fromCurrency,
    toCurrency,
    exactAmount,
    estimatedAmount,
    mode,
    fromCurrencyDecimals,
    toCurrencyDecimals,
  } = props;

  const fromToExchangeRate = BigNumber(exactAmount)
    .dividedBy(
      BigNumber(estimatedAmount).dividedBy(Math.pow(10, fromCurrencyDecimals))
    )
    .decimalPlaces(getMaxDisplayDecimals(Number(fromCurrencyDecimals)), 1)
    .toFixed()
    .toString();

  const toFromExchangeRate = BigNumber(
    BigNumber(estimatedAmount).dividedBy(Math.pow(10, fromCurrencyDecimals))
  )
    .dividedBy(exactAmount)
    .decimalPlaces(getMaxDisplayDecimals(Number(toCurrencyDecimals)), 1)
    .toFixed()
    .toString();

  const fromToExchangeRateDisplay = `1 ${fromCurrency} = ${displayAmount(
    fromToExchangeRate,
    0
  )} ${toCurrency}`;
  const toFromExchangeRateDisplay = `1 ${toCurrency} = ${displayAmount(
    toFromExchangeRate,
    0
  )} ${fromCurrency}`;

  return `${fromToExchangeRateDisplay} \n ${toFromExchangeRateDisplay}`;
};

export const getExchangeRateDisplay = (props: IProps) => {
  const {
    fromCurrency,
    toCurrency,
    exactAmount,
    estimatedAmount,
    mode,
    fromCurrencyDecimals,
    toCurrencyDecimals,
  } = props;

  if (!fromCurrency || !toCurrency || !exactAmount || !estimatedAmount) {
    return "-";
  }

  if (mode === TabTypes.EXACT_PAY) {
    return createExactPayExchangeRateDisplay({
      fromCurrency,
      toCurrency,
      exactAmount,
      estimatedAmount,
      mode,
      fromCurrencyDecimals,
      toCurrencyDecimals,
    });
  } else if (mode === TabTypes.EXACT_GET) {
    return createExactGetExchangeRateDisplay({
      fromCurrency,
      toCurrency,
      estimatedAmount,
      exactAmount,
      mode,
      fromCurrencyDecimals,
      toCurrencyDecimals,
    });
  }
};
